'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateDiscoverLinks = undefined;

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _uniqWith = require('lodash/uniqWith');

var _uniqWith2 = _interopRequireDefault(_uniqWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateDiscoverLinks = exports.generateDiscoverLinks = function generateDiscoverLinks(facets, createCategoryLandingLink) {
    var discoverItems = [];
    var shouldCreateMat = true;
    var shouldCreateCreator = true;

    if (facets && facets.categories && facets.categories.length > 0 && facets.creators) {
        facets.creators.some(function (creator, index) {
            discoverItems.push(createCategoryLandingLink(facets.categories[0], creator));
            return index === 1;
        });

        shouldCreateCreator = false;
    }

    if (facets && facets.creators && facets.creators.length > 0 && shouldCreateCreator) {
        discoverItems.push(createCategoryLandingLink(facets.creators[0]));
    }

    if (facets && facets.materialsTechniques && facets.categories && facets.categories.length > 0) {
        facets.materialsTechniques.some(function (materialsTechniques, index) {
            discoverItems.push(createCategoryLandingLink(facets.categories[0], materialsTechniques));
            return index === 1;
        });

        shouldCreateMat = false;
    }

    if (facets && facets.materialsTechniques && facets.materialsTechniques.length > 0 && shouldCreateMat) {
        discoverItems.push(createCategoryLandingLink(facets.materialsTechniques[0]));
    }
    if (facets && facets.categories && facets.categories.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.categories[0]));
    }
    if (facets && facets.stylePeriods && facets.stylePeriods.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.stylePeriods[0]));
    }
    if (facets && facets.origins && facets.origins.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.origins[0]));
    }

    return (0, _uniqWith2.default)(discoverItems, _isEqual2.default);
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/discoverItems.js
// module id = nmQq
// module chunks = 46